export default __webpack_public_path__ + "static/HomepageFooterCtaBg-bc356ddf758829e43536eb0c8985601f.webp";